import { useTranslation } from "react-i18next"
import { Check } from "@phosphor-icons/react"
import { Chip } from "@/components/ui/chip"
import { normalizeTestId } from "@/lib/test-helper"

interface BooleanSelectProps extends React.ComponentPropsWithoutRef<typeof Chip> {
  label: string
  "data-testid"?: string
}

const BooleanSelect = ({ label, "data-testid": dataTestId, ...rest }: BooleanSelectProps) => {
  const { t } = useTranslation()
  return (
    <Chip
      className="h-8 cursor-pointer gap-0.5"
      type="button"
      data-testid={dataTestId && normalizeTestId(dataTestId, "-boolean-select")}
      {...rest}
      onCheckedChange={(value) => {
        rest.onCheckedChange?.(value)
      }}>
      <div className="w-0 overflow-hidden transition-all duration-200 group-data-[state=checked]:w-5">
        <Check size={20} />
      </div>
      <span className="group-data-[state=checked]:pl-1.5">{t(label)}</span>
    </Chip>
  )
}

export { BooleanSelect }
